import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faComments, faHashtag, faHome, faQuestion, faSitemap, faSquarePollVertical, faTableCells, } from '@fortawesome/free-solid-svg-icons';
export const NavItems = () => {
    const location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, { className: location.pathname === '/'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/" },
            React.createElement(FontAwesomeIcon, { icon: faHome }),
            "Home"),
        React.createElement(Link, { className: location.pathname.includes('/quizzes')
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/quizzes" },
            React.createElement(FontAwesomeIcon, { icon: faQuestion }),
            "Quizzes"),
        React.createElement(Link, { className: location.pathname === '/crosswords'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/crosswords" },
            React.createElement(FontAwesomeIcon, { icon: faHashtag }),
            "Crosswords"),
        React.createElement(Link, { className: location.pathname === '/word-searches'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/word-searches" },
            React.createElement(FontAwesomeIcon, { icon: faTableCells }),
            "Word Searches"),
        React.createElement(Link, { className: location.pathname === '/surveys'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/surveys" },
            React.createElement(FontAwesomeIcon, { icon: faSquarePollVertical }),
            "Surveys"),
        React.createElement(Link, { className: location.pathname === '/interactive-quizzes'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/interactive-quizzes" },
            React.createElement(FontAwesomeIcon, { icon: faComments }),
            "Interactive Quizzes"),
        React.createElement(Link, { className: location.pathname === '/library'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/library" },
            React.createElement(FontAwesomeIcon, { icon: faBook }),
            "Library"),
        React.createElement(Link, { className: location.pathname === '/organisations'
                ? 'nav-pane__link nav-pane__link-active'
                : 'nav-pane__link', to: "/organisations" },
            React.createElement(FontAwesomeIcon, { icon: faSitemap }),
            "Organisations")));
};
